import React, { useEffect, useState } from 'react';
import { axiosPrivate } from '../../../Apis/axios';
import useAuth from '../../../Hooks/useAuth';

function Create(props) {
    const url = "/organisations";
    const { auth } = useAuth();
    const [error, setError] = useState();  
    const [success, setSuccess] = useState();  
    const [submit, setSubmit] = useState("Create");
    
    async function handleCreate(event){
        event.preventDefault();
        event.target.elements.submitBtn.disabled = true;
        setSubmit(<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>Loading...</>)
        
        //console.log(auth.userId);

        const inputValues = {
            name: event.target.elements.name.value,
            email: event.target.elements.email.value,
            telephone: event.target.elements.telephone.value,
            userId: auth.userId,
            address: event.target.elements.address.value,
            description: event.target.elements.address.value
        }    

        //console.log(inputValues);
        
        try{
            // Axios API.
            const response = await axiosPrivate.post(url, 

                JSON.stringify(inputValues), 
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
                
                event.target.elements.submitBtn.disabled = false;
                setSubmit("Create");
                
            console.log(response?.data);
            // Print Out Responses.

            setSuccess("Corporate client created successfully.");
            window.location.reload(false);

        }catch(e){
            event.target.elements.submitBtn.disabled = false;
            setSubmit("Create");
            setSuccess("");
            if (e.response.data.error.hasOwnProperty("errors")){
                setError(e.response.data.error.errors[0].message);
            }else{
                setError(e.response.data.error);
                console.error(e);
            }
        }
    }

  return (
    <div className="modal fade" id="organisationModal" tabIndex="-1" role="dialog" aria-labelledby="#organisationModal" aria-hidden="true">
        <div className="modal-dialog modal-md" role="document">
            <div className="modal-content border-0">
                <form onSubmit={handleCreate}>
                    <div className="modal-header py-2 text-white bg-dark">
                        <h5 className="modal-title" id="exampleModalLongTitle">Create Corporate Client</h5>
                    </div>
    
                    <div className="modal-body py-3">
                    <span className="text-danger small"><b>{error}</b></span>
                    <span className="text-success small"><b>{success}</b></span>

                        <div className="row py-3">
                            <div className="col-md-5 px-2">
                                <label htmlFor="clientInput" className='font-weight-medium'>Corporate Client: <span className='text-danger'>*</span></label>
                                <input type="text" id='clientInput' name='name' className='form-control form-control-sm'  placeholder='Corporate Client' required />
                            </div>
                            <div className="col-md-7 px-2">
                                <label htmlFor="emailInput" className='font-weight-medium'>Email: <span className='text-danger'>*</span></label>
                                <input type="email" id='emailInput' name='email' className='form-control form-control-sm'  placeholder='Email' required />
                            </div>
                        </div>

                        <div className="row py-3">
                            
                            <div className="col-md-5 px-2">
                                <label htmlFor="telInput" className='font-weight-medium'>Phone NO.: <span className='text-danger'>*</span></label>
                                <input type="tel" id='telInput' name='telephone' className='form-control form-control-sm'  placeholder='Phone NO.'  />
                            </div>
                            
                            <div className="col-md-7 px-2">
                                <label htmlFor="address" className='font-weight-medium'>Address: <span className='text-danger'></span></label>
                                <input type="text" id='address' name='address' className='form-control form-control-sm'  placeholder='Address' />
                            </div>
                        </div>
                       
                        <div className="row py-3">

                            <div className="col px-2">
                                <label htmlFor="descInput" className='font-weight-medium'>Description: <span className='text-danger'></span></label>
                                <textarea name="description" className="form-control form-control-sm" id="descInput" cols="30" rows="3"></textarea>
                            </div>

                        </div>
                        
                    </div>

                    <div className="modal-footer py-1">
                        <button type="button" className="btn btn-sm btn-dark" data-dismiss="modal" aria-label="Close">Close</button>
                        <button type="submit" name="submitBtn" className="btn btn-danger btn-sm">
                            {submit}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  );
}

export default Create;